
export class SettingsKeyLog {
    constructor(
        public id: number = null,
        public name: string = '',
        public uniqueTags: boolean = false,
        public mandatoryUnitToKey: boolean = false,
        public useSignaturePadStatus: boolean = false,
        public staffNotificationSettings: Array<any> = [],
        public formFields = {
            defaultPaymentMethod: {editMode: false}
        },
        public createdBy: string = '',
        public createdAt: string = '',
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/SettingsKeyLog.ts